import AbstractListView from '@UI/Store/AbstractListView';
import type UserView from '@UI/Store/Users/Views/UserView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries `totalRecords` alongside the page's `list`: the list is paginated server-side, and the
 * page runs with `cache: CACHE_DISABLED` (no server re-read after a mutation), so `totalRecords`
 * must be maintained by every helper below rather than recomputed from `list.length`.
 */
class UsersListView extends AbstractListView<UserView> {
	readonly accountId: number;
	readonly totalRecords: number;

	constructor(list: readonly UserView[], accountId: number, totalRecords: number) {
		super(list, 'UsersListView');

		this.accountId = accountId;
		this.totalRecords = totalRecords;

		Object.freeze(this);
	}

	static replaceAll(list: readonly UserView[], accountId: number, totalRecords: number): UsersListView {
		return new UsersListView(list, accountId, totalRecords);
	}

	addUser(user: UserView): UsersListView {
		return new UsersListView([...this.list, user], this.accountId, this.totalRecords + 1);
	}

	removeUser(userId: number): UsersListView {
		return new UsersListView(
			this.list.filter((entry) => entry.id !== userId),
			this.accountId,
			this.totalRecords - 1,
		);
	}

	updateUser(user: UserView): UsersListView {
		return new UsersListView(
			this.list.map((entry) => (entry.id === user.id ? user : entry)),
			this.accountId,
			this.totalRecords,
		);
	}
}

export default UsersListView;
